export const requestDemo = 'requestDemo';
export const FILE_NOW_TEXT = 'File Now';
export const REQUEST_DEMO_TEXT = 'Request a demo';
export const BOOK_DEMO_TEXT = 'Book a demo';
export const CONTACT_US_TEXT = 'Contact Us';
export const BOOK_EXPERT_TEXT = 'Book your Expert';

export enum CTA_KEY {
  CURRENCY_CONVERTER_CTA = 'currency_converter',
  IFSC_CTA = 'ifsc',
  GOLD_SILVER_CTA = 'gold_silver',
  STOCKS_CTA = 'stocks',
}
